<template>
  <div class="wrapper">
    <div class="row mt-2">
      <div class="col-md">
        <label>Befehle-Testen:</label>
      </div>
      <div class="col-md">
        <label>Chat-Befehl:</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="input-group">
          <input v-model="testtext" placeholder="Nachricht zum testen" class="form-control" type="text"/>
          <div class="input-group-append">
            <button @click="testText" class="btn btn-secondary"><font-awesome-icon icon="vial"/></button>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="input-group">
          <select @change="selectCmd" v-model="selcmd" class="form-control">
            <option v-for="(item,idx) in commands" :key="item.id" :value="idx">{{ item.id }}</option>
          </select>
          <div class="input-group-append">
            <button @click="addCommand" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
          </div>
        </div>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-md" style="height:500px;">
        <AceEditor ref="cmdeditor" :editorId='"cmdEditor"' lang="javascript" :content="''"/>
      </div>
      <div class="col-md">
        <div class="form-group">
          <label>Befehl-Name:</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <button @click="saveCommand" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
            </div>
            <input v-model="current.id" placeholder="Kurzer Name für den Befehl" class="form-control" type="text"/>
            <div class="input-group-append">
              <button @click="deleteCommand" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
          </div>
          <small class="form-text text-muted">Der Name muss auch als Funktionsname genutzt werden z.B. MeinBefehl => function MeinBefehl() { ... }</small>
        </div>
        <div class="row">
          <div class="col">
            <strong>Freigabe für: </strong>
          </div>
          <div class="col">
            <div class="form-check">
              <input type="checkbox" value="0" @change="setAllowed('Customer',custAllowed,0)" v-model="custAllowed" class="from-check-input" id="customerCmd"/>
              <label class="ml-2" for="customerCmd">Kunden</label>
            </div>
          </div>
          <div class="col">
            <div class="form-check">
              <input type="checkbox" value="1" @change="setAllowed('LocalUser',userAllowed,2)" class="from-check-input" v-model="userAllowed" id="customerCmd"/>
              <label class="ml-2" for="customerCmd">Innendienst</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Priorit&auml;t:</label>
          <input v-model="current.priority" placeholder="Reihenfolge" class="form-control" type="text"/>
        </div>
        <div class="form-group">
          <label>Beispiel:</label>
          <input v-model="current.example" placeholder="Kurzes Beispiel: Artikel 12345" class="form-control" type="text"/>
        </div>
        <div class="form-group">
          <label class="mr-2">Satzmuster:</label>
        </div>
        <ul class="list-group">
          <li class="list-group-item">
            <div class="row">
              <div class="col-md">
                <input class="form-control" placeholder="Name" v-model="patternkey" type="text"/>
              </div>
              <div class="col-xs"><strong>=</strong></div>
              <div class="col-md">
                <input class="form-control" type="text" v-model="patternval" placeholder="Regex Muster"/>
              </div>
              <div class="col-xs">
                <button @click="addPattern" class="btn btn-primary" name="rempattern"><font-awesome-icon icon="plus"/></button>
              </div>
            </div>
          </li>
          <li class="list-group-item" v-for="(val,key) in patterns" :key="key">
            <div class="row">
              <div class="col-md">
                <input disabled class="form-control" placeholder="Name" :value="key" type="text"/>
              </div>
              <div class="col-xs"><strong>=</strong></div>
              <div class="col-md">
                <input class="form-control" type="text" v-model="patterns[key]" placeholder="Regex Muster"/>
              </div>
              <div class="col-xs">
                <button @click="remPattern(key)" class="btn btn-danger" name="rempattern"><font-awesome-icon icon="trash"/></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <b-modal id="chattestresult" title="Testergebniss" ok-only>
      <div class="row">
        <div class="col-md">
          <div class="form-group">
            <label>Befehl:</label>
            <input type="text" disabled :value="testresult.runcmd.id"/>
          </div>
          <div class="form-group">
            <label>Priorität:</label>
            <input type="text" disabled :value="testresult.runcmd.prio"/>
          </div>
        </div>
        <div class="col-md">
          <h5>Parameter</h5>
          <div v-for="(val,key) in testresult.params" :key="key" class="row">
            <div class="col-md"><b>{{ key }}</b></div>
            <div class="col-md">{{ val }}</div>
          </div>
        </div>
      </div>
    </b-modal>
    <div style="display:hidden;">
    </div>
  </div>
</template>

<script>
//import config from '@/modules/config.js'
import chatbot from '@/modules/chatbot.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'ChatBotCommands',
  components: {
    AceEditor,
  },
  data() {
    return {
      commands: [],
      custAllowed: false,
      userAllowed: false,
      current: {isnew:true,allowed:{}},
      patterns: {},
      patternkey: '',
      patternval: '',
      selcmd: -1,
      testtext: '',
      testresult: { runcmd: {}, params: {}},
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      chatbot.commands(this,function(data) {
        self.commands = data;
      })
    },
    addCommand: function() {
      this.current = {isnew: true,id:'',allowed: {}};
      this.custAllowed = this.current.allowed;
      this.$refs.cmdeditor.setContent('');
    },
    testText: function() {
      console.log(this.testtext);
      if (this.testtext == '') {
        this.$bvToast.toast('Bitte erst eine Beispielnachricht eingeben.',{title:'Chat Bot Test',variant:'warning'})
        return;
      }
      var self = this;
      chatbot.testcmds(this,this.testtext,function(data) {
        console.log(data);
        self.testresult = data;
        if (data.runcmd) {
          self.$bvModal.show('chattestresult');
        } else {
          self.$bvToast.toast('Kein Treffer erhalten.',{title:'Chat Bot Test',variant:'warning'})
        }
      })
    },
    remPattern: function(key) {
      console.log('rem pattern: ' + key);
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.patterns));
      delete temp[key];
      this.patterns = temp;
      console.log(temp);
    },
    selectCmd: function() {
      console.log(this.selcmd);
      this.current  = this.commands[this.selcmd];
      this.custAllowed = this.current.allowed && this.current.allowed["Customer"] !== undefined;
      this.userAllowed = this.current.allowed && this.current.allowed["LocalUser"] !== undefined;
      this.patterns = this.current.patterns;
      this.$refs.cmdeditor.setContent(this.current.script);
    },
    addPattern: function() {
      console.log('add pattern: ' + this.patternkey);
      if (this.patternkey === '') {
        this.$bvToast.toast('Bitte erst einen kurzen Namen für das Muster eingeben.',{title:'ChatBot',variant:'warning'})
        return;
      }
      // vue and bad data design workaround :(
      var temp = JSON.parse(JSON.stringify(this.patterns));
      temp[this.patternkey] = this.patternval;
      this.patterns = temp;
      this.patternkey = '';
      this.patternval = '';
    },
    deleteCommand: function() {
      if (this.current.isnew) {
        this.addCommand();
        return;
      }
      if (confirm('Möchten Sie wirkliche den Befehl: ' + this.current.id + ' löschen?')) {
        var self = this;
        chatbot.delcmd(this,this.current.id,function() {
          self.commands.splice(self.selcmd,1);
          self.addCommand();
        })
      }
    },
    saveCommand: function() {
      console.log(JSON.stringify(this.current));
      if (this.current.isnew) {
        if (!this.current.id || this.current.id == '') {
          this.$bvToast.toast('Bitte erst einen eindeutigen Namen eingeben.',{title: 'Chat Bot Cmd',variant: 'success'});
          return;
        }
        this.commands.push(this.current);
        this.current.isnew = false;
      }
      var self = this;
      this.current.script   = this.$refs.cmdeditor.getContent();
      this.current.patterns = this.patterns;
      chatbot.savecmd(this,this.current,function() {
        self.$bvToast.toast('Befehl gespeichert.',{title: 'ChatBot',variant:'success'});
      })
    },
    setAllowed(key,allowed,value) {
      if (allowed)
        this.current.allowed[key] = value;
      else
        delete this.current.allowed[key];
    }
  }
}
</script>
